import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
export const EmptyCart = () => {
    const { t } = useTranslation("c-cart");
    return (React.createElement(Box, { sx: { mt: 2, mb: { xs: 8, sm: 0 } } },
        React.createElement(Typography, { variant: "body1" }, t("empty-cart-body1", "Dein Warenkorb ist gegenwärtig leer.")),
        React.createElement(Button, { color: "primary", href: "/", LinkComponent: Link, variant: "contained", sx: { mt: 3 } }, t("button-empty-cart-redirect", "Zu unseren Krimidinner Spielen"))));
};
//# sourceMappingURL=empty-cart.js.map